// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__21vai","clinicsSelect":"TableHeading_clinicsSelect__1sP4n"};